import { translate } from "@td/shared_utils";
import { object, number } from 'yup';

export default object({
  chartSize: number().typeError(translate(null, 'state_chart_review.config_form.fields.validation.chart_size_integer'))
    .required(translate(null, 'state_chart_review.config_form.fields.validation.chart_size_required'))
    .integer(translate(null, 'state_chart_review.config_form.fields.validation.chart_size_integer'))
    .min(0, translate(null, 'state_chart_review.config_form.fields.validation.chart_size_positive')),
  chartType: object()
    .required(translate(null, 'state_chart_review.config_form.fields.validation.chart_type_required'))
});
